import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";

import { Modal, Button } from "semantic-ui-react";

import { isRequestActive } from "redux-request-loading";
import { Link } from "@teamprevent/common/task/taskActions/models";

import { ApplicationState } from "../applicationState";

import { changeCurrentUserCompanyContext } from "../auth/actions";
import * as actionTypes from "../auth/actionTypes";

export const CustomerIdMismatchErrorModal: React.FC = () => {
    const dispatch = useDispatch();
    const currentCustomer = useSelector<ApplicationState, Link | undefined>(state => state.currentUser.currentCustomer);
    const mismatchedCustomer = useSelector<ApplicationState, true | undefined>(state => state.currentUser.mismatchedCustomer);
    const isSwitching = useSelector<ApplicationState, boolean>(state => isRequestActive(state, actionTypes.GET_CURRENT_USER));

    const onContinue = React.useCallback(async () => {
        dispatch(changeCurrentUserCompanyContext(currentCustomer.id));
    }, [currentCustomer?.id, dispatch]);

    return (
        <Modal open={mismatchedCustomer !== undefined}>
            <Modal.Header>Company Mismatch</Modal.Header>
            <Modal.Content>
                The current request is for {currentCustomer?.name} but you appear to have switched to another company in another browser window or tab. <br />
                Press the continue button to switch back to {currentCustomer?.name} and then reattempt your action.
            </Modal.Content>
            <Modal.Actions>
                <Button loading={isSwitching} disabled={isSwitching} content="Continue" onClick={onContinue} />
            </Modal.Actions>
        </Modal>
    );
};
